
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8.75h15.213L8.224 1.763 10 0l10 10-10 10-1.762-1.762 6.975-6.988H0v-2.5z","fill":"#fff"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"20","height":"20"}},[_c('path',{attrs:{"d":"M0 8.75h15.213L8.224 1.763 10 0l10 10-10 10-1.762-1.762 6.975-6.988H0v-2.5z","fill":"#fff"}})])])
          )
        }
      }
    